export default __webpack_public_path__ + "static/media/github.a21daf3d.svg";